import React from 'react';

interface LogoProps {
  size?: number;
  variant?: 'icon' | 'full';
  className?: string;
}

export default function Logo({ size = 36, variant = 'icon', className = '' }: LogoProps) {
  if (variant === 'full') {
    // logo-full.png: 1055×1153 px → aspect ratio ≈ 0.915 (portrait)
    const fullWidth = Math.round(size * (1055 / 1153));
    return (
      <img
        src="/logo-full.png"
        alt="Grenzland Padel Liga"
        width={fullWidth}
        height={size}
        style={{ width: fullWidth, height: size, objectFit: 'contain' }}
        className={className}
      />
    );
  }

  // logo-icon.png: 1055×769 px → aspect ratio ≈ 1.37 (landscape)
  const iconWidth = Math.round(size * (1055 / 769));
  return (
    <img
      src="/logo-icon.png"
      alt="Grenzland Padel Liga"
      width={iconWidth}
      height={size}
      style={{ width: iconWidth, height: size, objectFit: 'contain' }}
      className={className}
    />
  );
}
